(function (module) {

    module.service('configurationPeriodService', ['$http', configurationPeriodService])

    function configurationPeriodService(this: $TSFixMe, $http: ng.IHttpService) {
        var service = this;

        service.save = function (periods: $TSFixMe) {
            return $http.post('/api/configuration', periods);
        };

        service.get = function () {
            return $http.get('/api/configuration')
                .then(function (response: $TSFixMe) { return response.data; });
        }
    }

})(angular.module('topline.modules'));